import { AxiosResponse } from 'axios';
import { BaseApi } from '@/main/baseApi';
import { API_ND_AREA } from '@/modules/sklad/constants';
import { NAME as ND_SKLAD_NAME, NASLEDNICI_KEY, PREDCHUDCI_KEY, SHODA_KEY, NdSklad } from '@/modules/sklad/ndSklad/constants';
import { API_POHYB_ZAKAZKA, NAME as ND_POHYB_NAME } from '@/modules/sklad/ndPohyb/constants';

import {
	DependentTableNames,
	DMS_MODULE,
	NAME,
	ZAKAZKAND_NASLEDNICI,
	ZAKAZKAND_POHYB,
	ZAKAZKAND_PREDCHUDCE,
	ZAKAZKAND_SHODA,
	ZAKAZKAND_CAMPAIGN,
	SERVICE_JOB_SPLIT_BILLING,
} from './constants';
import { SPLIT_BILLING } from '../pracovniPozice/constants';

class ZakazkaNdProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async defaultJfnd(filter: {}) {
		return this.post(`/${DMS_MODULE}/${NAME}/defaultForJfnd`, filter);
	}

	async oceneniNd(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/OceneniNd`, params);
	}

	async checkExistsSkladovyPrevod(params: any): Promise<AxiosResponse<boolean>> {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CheckExistsSkladovyPrevod`, params);
	}

	async checkExistsJfnd(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ExistsJfnd`, params);
	}

	async getForJfnd(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetForJfnd`, params);
	}

	async getIdentickyNd(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetIdentickyNd`, params);
	}

	async vydejVratka(params: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/VydejVratka`, params);
	}

	async cancelSP(params: { zaznamId: number, cancellationReason: string, cancellationType: number }) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CancelSP`, params);
	}

	async checkExistsSk(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/CheckExistsSk`, params);
	}

	async markPartsAsComplte(params: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/MarkPartsAsComplte`, params);
	}

	async markPartsAsAdditional(params: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/MarkPartsAsAdditional`, params);
	}

	async markPartsAsDelete(params: any) {
		return this.post(`/${DMS_MODULE}/${NAME}/MarkPartsAsDelete`, params);
	}

	async getAvailableQuantity(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetAvailableQuantity`, params);
	}

	async sendEmailAndSmsNotification(ZaznamId:number) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendEmailAndSmsNotification?ZaznamId=${ZaznamId}`);
	}

	async sendEmailAndSmsApprovalNotification(ZakazkaId: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendEmailAndSmsApprovalNotification?ZakazkaId=${ZakazkaId}&StatusCode=${StatusCode}`);
	}

	async setResetAdditionalJobStatus(ZakazkaId: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SetResetAdditionalJobStatus?ZakazkaId=${ZakazkaId}&StatusCode=${StatusCode}`);
	}

	async setResetAdditionalJobStatusZakazkaScreen(ZakazkaId: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SetResetAdditionalJobStatusZakazkaScreen?ZakazkaId=${ZakazkaId}&StatusCode=${StatusCode}`);
	}

	async setAdditionalStatusForZakazkaND(ZakazkaNd: number | null, StatusCode: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/SetAdditionalStatusForZakazkaNd?ZakazkaNd=${ZakazkaNd}&StatusCode=${StatusCode}`);
	}

	async deleteRejectedStatus(ZakazkaId: number | null) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteRejectedStatus?ZakazkaId=${ZakazkaId}`);
	}

	tiskVydejka(zakazkaId: number, allTerminal = true) {
		return this.post(`/${DMS_MODULE}/${NAME}/TiskVydejka/?zakazkaId=${zakazkaId}&bAllTerminal=${allTerminal}`);
	}

	getVydejkaNDReport(ndpohybdoklId: number) {
		return this.fetchReport('GetVydejkaNDReport', { id: ndpohybdoklId });
	}

	insertDiscount(myZakazkaNDId: number, myDiscountPrc: number, myDiscountVal: number) {
		return this.fetch(`/${DMS_MODULE}/Zakazka/insertDiscount`, { myZakazkaNDId, myDiscountPrc, myDiscountVal });
	}

	async sendThresholdNotification(vyrobekndOzn: string, ndNr: string, skladOzn: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/SendThresholdNotification?vyrobekndOzn=${vyrobekndOzn}&ndNr=${ndNr}&skladOzn=${skladOzn}`);
	}

	gerMpr(partNo: string,brand:string) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetMrp`, { partNo, brand });
	}

	uploadParts(fileList: any, ZakazkaId: null | number, Stav: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/UploadParts?zakazkaId=${ZakazkaId}&Stav=${Stav}`, file);
	}

	getSplitDetails(itemId: number | null, orderId: number | null) {
		return this.fetch(`/${DMS_MODULE}/SplitBilling/GetSplitTooltip`, { itemId, orderId });
	}

	getPricing(partNo: string,brand:string, orderId: number, warehouseId:any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetPrice`, { partNo, brand,orderId, warehouseId });
	}
	getNdpDate(pricingId: number, orderId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetNdp`, { pricingId, orderId });
	}
	fetchInvoiceStatusOfServiceJobParty(serviceOrderId: number, serviceJobId: number, itemId: number, itemType: string, discountLimitPercent: number) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/FetchInvoiceStatusOfServiceJobParty`, { serviceOrderId, serviceJobId, itemId, itemType, discountLimitPercent });
	}
	validateServiceJobWhileReservationPartInsertion(serviceJobId: number, serviceOrderId: number, mrpId: number, lineLevelDiscountLimitPercent: number | null, rrpUnitPrice: number, quantity: number, warehouseId: number, partCategory: string, partNumber: string) {
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/ValidateServiceJobWhileReservationPartInsertion`, { serviceJobId, serviceOrderId, mrpId, lineLevelDiscountLimitPercent, rrpUnitPrice, quantity, warehouseId, partCategory, partNumber });
	}
	isPartOrLabourInvoiced(orderId: number, itemId: number, itemType: string) {
		return this.fetch(`/${DMS_MODULE}/${SPLIT_BILLING}/IsPartOrLabourInvoiced`,{orderId, itemId, itemType});
	}
	isWarrantyOrGoodwillSplitExists( itemId: number, orderId:number, itemType:string){
		return this.fetch(`/${DMS_MODULE}/${SPLIT_BILLING}/IsWarrantyOrGoodWillSplitExist`,{itemId, orderId, itemType});
	}
	isWarrantyOrGoodwillExistInServiceJobSplit(serviceOrderId:number, serviceJobId: number){
		return this.fetch(`/${DMS_MODULE}/${SERVICE_JOB_SPLIT_BILLING}/IsWarrantyOrGoodWillSplitExistsInServiceJob`,{serviceOrderId, serviceJobId});
	}
		isAnySplitPartyInoviced(orderId:number|null, itemId:number|null, itemType:string){
		return this.fetch(`/${DMS_MODULE}/Zakazka/IsAnySplitPartyInoviced`,{orderId, itemId, itemType});
	}
	async getisObsoletePartStock(partNumber: string, warehouseId: number, brand: string, quantity: number) {
		return this.fetch(`/${API_ND_AREA}/${NdSklad}/GetIsObsoletePartStock?partNumber=${partNumber}&quantity=${quantity}&brand=${brand}&warehouseId=${warehouseId}&IsProrder=false`);
	}

	checktransferWaerhouse(partNo:string, orderId:number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ChecktransferWaerhouse`, { partNo, orderId });
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ZAKAZKAND_PREDCHUDCE:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${PREDCHUDCI_KEY}Schema`;
			case ZAKAZKAND_SHODA:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${SHODA_KEY}Schema`;
			case ZAKAZKAND_NASLEDNICI:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${NASLEDNICI_KEY}Schema`;
			case ZAKAZKAND_POHYB:
				return `/${API_ND_AREA}/${ND_POHYB_NAME}/${API_POHYB_ZAKAZKA}Schema`;
			case ZAKAZKAND_CAMPAIGN:
				return `/${DMS_MODULE}/Campaign/ItemCampaignSchema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case ZAKAZKAND_PREDCHUDCE:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${PREDCHUDCI_KEY}Rows`;
			case ZAKAZKAND_SHODA:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${SHODA_KEY}Rows`;
			case ZAKAZKAND_NASLEDNICI:
				return `/${API_ND_AREA}/${ND_SKLAD_NAME}/${NASLEDNICI_KEY}Rows`;
			case ZAKAZKAND_POHYB:
				return `/${API_ND_AREA}/${ND_POHYB_NAME}/${API_POHYB_ZAKAZKA}Rows`;
			case ZAKAZKAND_CAMPAIGN:
				return `/${DMS_MODULE}/Campaign/ItemCampaignRows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}
	async getRequiredDataForPartSelection(params: any) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GetRequiredDataForPartSelection`, params);
	}
}

export const apiProvider = new ZakazkaNdProvider();
